import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchScenarios = async () => {
  const { data } = await axios.get(`${API}/scenarios`, { params: { _: Date.now() } });
  return data.scenarios;
};

export const fetchScenario = async (id) => {
  const { data } = await axios.get(`${API}/scenario/${id}`, { params: { _: Date.now() } });
  return data;
};

export const saveSession = async (payload) => {
  const { data } = await axios.post(`${API}/sessions`, payload);
  return data;
};

export const fetchDebrief = async (sessionId) => {
  const { data } = await axios.post(`${API}/debrief`, { session_id: sessionId });
  return data;
};

export const fetchSceneAudio = async (scenarioId, decisionId) => {
  const res = await axios.post(
    `${API}/tts`,
    { scenario_id: scenarioId, decision_id: decisionId },
    { responseType: "blob" }
  );
  return URL.createObjectURL(res.data);
};

export const fetchSession = async (sessionId) => {
  const { data } = await axios.get(`${API}/sessions/${sessionId}`);
  return data;
};

export const fetchAllSessions = async (token) => {
  const { data } = await axios.get(`${API}/sessions`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const fetchKnowledgeQuestions = async () => {
  const { data } = await axios.get(`${API}/knowledge-check`);
  return data.questions;
};

export const submitKnowledgeCheck = async (payload) => {
  const { data } = await axios.post(`${API}/knowledge-check/submit`, payload);
  return data;
};

export const fetchKnowledgeChecks = async (token) => {
  const { data } = await axios.get(`${API}/knowledge-checks`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const submitFeedback = async (payload) => {
  const { data } = await axios.post(`${API}/feedback`, payload);
  return data;
};

export const fetchFeedback = async (token) => {
  const { data } = await axios.get(`${API}/feedback`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const downloadExportZip = async (token) => {
  const res = await axios.get(`${API}/export.zip`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });
  return res.data;
};

export const facilitatorStatus = async () => {
  const { data } = await axios.get(`${API}/facilitator/status`);
  return data.configured;
};

export const facilitatorSetup = async (passcode, setupKey) => {
  const { data } = await axios.post(`${API}/facilitator/setup`, { passcode, setup_key: setupKey });
  return data.token;
};

export const facilitatorVerify = async (passcode) => {
  const { data } = await axios.post(`${API}/facilitator/verify`, { passcode });
  return data.token;
};
